import _extends from "@babel/runtime/helpers/extends";
import React, { useImperativeHandle } from 'react';
import { useOverviewMapControl } from './useOverviewMapControl';
export * from './useOverviewMapControl';
export default /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
    overviewMapControl
  } = useOverviewMapControl(props);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useImperativeHandle(ref, () => _extends({}, props, {
    overviewMapControl
  }), [overviewMapControl]);
  return null;
});